module.exports = __webpack_public_path__ + "media/images/lb/634-c9e0db6e11ac8ffd595a95f9bccd009f.svg";